import React from 'react';
import tw from 'twin.macro';

interface Props {
  children: [React.ReactNode, React.ReactNode];
}

const CARD_STYLE = tw`h-full p-6 md:px-8 rounded-lg bg-neutral-supershy`;

export function MesssageWrapper(props: Props) {
  const { children } = props;

  // En gros si on a pas de message on affiche seulement le vrai body
  if (!children[0]) {
    return <div css={[CARD_STYLE]}>{children[1]}</div>;
  }

  return (
    <div css={[CARD_STYLE, tw`grid lg:grid-cols-8`]}>
      <div tw="h-full flex flex-col lg:flex-row lg:col-span-3">
        {children[0]}
        <div
          css={[
            tw`h-3 flex items-center justify-center -mx-2 py-8`,
            tw`lg:h-full lg:w-3 lg:mx-0 lg:px-8 lg:py-2`,
          ]}
        >
          <div tw="w-full border-neutral-quiet border-t lg:h-full lg:border-r" />
        </div>
      </div>
      <div tw="lg:col-span-5">{children[1]}</div>
    </div>
  );
}
